import { FormPhoneField, FormTextField } from '@skupreme/shared/ui/form';
import type { StepProps } from './types';

type ContactStepProps = StepProps & {
  /** The location step's country, so the phone starts on its dial code. */
  countryFlag?: string;
  isExtensiv: boolean;
  onDialCodeLengthChange: (length: number) => void;
};

export function ContactStep({
  control,
  fieldError,
  isVisible,
  countryFlag,
  isExtensiv,
  onDialCodeLengthChange,
}: ContactStepProps) {
  return (
    <div className={isVisible ? 'sk:flex sk:flex-col sk:gap-4' : 'sk:hidden'}>
      {isExtensiv ? (
        <p className="sk:m-0 sk:text-dense sk:text-fg-secondary">
          We will be getting in touch with your third-party storage provider to
          initiate the configuration.
        </p>
      ) : null}
      <div className="sk:grid sk:grid-cols-2 sk:gap-4">
        <FormTextField
          control={control}
          name="contact_name"
          label="Contact Person (Full Name)"
          error={fieldError('contact_name')}
          isRequired={isVisible}
        />
        <FormPhoneField
          control={control}
          name="contact_phone"
          label="Phone"
          error={fieldError('contact_phone')}
          defaultCountry={countryFlag}
          isRequired={isVisible}
          onDialCodeChange={onDialCodeLengthChange}
        />
        <FormTextField
          control={control}
          name="contact_email"
          label="E-Mail Address"
          error={fieldError('contact_email')}
          isRequired={isVisible}
        />
        <FormTextField
          control={control}
          name="contact_fax"
          label="Fax"
          error={fieldError('contact_fax')}
        />
      </div>
    </div>
  );
}
